import {
  Box,
  Flex,
  Text,
  Menu,
  MenuList,
  MenuItem,
  MenuButton,
  MenuGroup,
  MenuDivider,
  Image,
  useToast,
  useClipboard,
  Heading,
  Stack,
  Switch
} from '@chakra-ui/core'

import axios from 'axios'

import NextLink from 'next/link'

const EventTypeItem = ({
  title,
  background,
  emoji,
  description,
  onDelete,
  onEdit,
  slug,
  type,
  id,
  status,
  duration,
  onSwitched,
  createEndpoint
}) => {
  const { onCopy } = useClipboard(`${window.location.origin}/book/${slug}`)
  const toast = useToast()

  const copyToClipboard = () => {
    onCopy(slug)
    toast({
      title: 'URL copied to clipboard!',
      description: 'Now share it with people you want to remind to :)',
      status: 'success',
      duration: 1700
    })
  }

  const onTypeToggle = async (e) => {
    try {
      await axios.put(`${createEndpoint}/${id}`, {
        status: e.target.checked ? 'active' : 'inactive'
      })
    } catch (e) {
      console.error(e)
    }

    onSwitched()
  }

  const thumbnail =
    background && background.formats
      ? background.formats.find(elem => elem.type === 'thumbnail')?.url
      : null

  return (
    <Box
      position='relative'
      height='100%' marginBottom='16px'
      padding='24px' borderRadius='12px'
      background='#fff'
    >
      <Flex
        overflow='hidden'
        height='100%'
        justifyContent='space-between'
        flexDirection={['column', 'row', 'row', 'row']}
      >
        <NextLink passHref href={`/book/${slug}`}>
          <Box display='flex' as='a' flexDirection={['column', 'row', 'row', 'row']}>
            <Box
              background={
              thumbnail
                ? `url('${thumbnail}')`
                : '#F1F2F3'
            }
              border={thumbnail ? '1px solid transparent' : '1px solid #e3e3e3'}
              backgroundSize='cover'
              backgroundPosition='center'
              width={['100%', '121px', '121px', '121px']}
              height={['140px', '74px', '74px', '74px']}
              borderRadius='12px'
              position='relative'
              marginRight={['0', '16px', '16px', '16px']}
              marginBottom={['20px', '0', '0', '0']}
              flexShrink='0'
            >
              {!thumbnail && (
                <Flex
                  position='absolute'
                  height='100%'
                  width='60%'
                  left='50%'
                  transform='translateX(-50%)'
                  justifyContent='space-around'
                  alignItems='center'
                >
                  <Image position='relative' top='3px' src='/static/no-photo.svg' alt='no photo' />
                </Flex>
              )}
            </Box>
            <Box marginBottom={['20px', '0', '0', '0']}>
              <Heading
                as='h2' color='#12151F' lineHeight='112.5%'
                fontSize='1.125rem' marginBottom='5px'
                fontWeight='700' className='type-title'
              >{title}
              </Heading>
              <Text
                className='type-description'
                fontSize='0.875rem'
                lineHeight='125%'
                color='#6A6E7D'
                marginBottom='10px'
              >
                {description}
              </Text>
              <Flex>
                <Text fontSize='0.875rem' lineHeight='150%' marginRight='4px' color='#A3A3A3'>
                  Duration
                </Text>
                <Text color='#12151F' fontSize='0.875rem' lineHeight='150%' marginRight='14px'>
                  {duration / 1000 / 60}{' '}
                  mins
                </Text>
                {
                  // todo count booked users
                }
                {/* <Text fontSize='0.875rem' lineHeight='150%' marginRight='4px' color='#A3A3A3'>
                  Booked
                </Text>
                <Text color='#12151F' fontSize='0.875rem' lineHeight='150%'>
                  2
                </Text> */}
              </Flex>
            </Box>
          </Box>
        </NextLink>
        <Flex alignItems='center' onClick={(e) => e.stopPropagation()} justifyContent={['space-between', 'initial', 'initial', 'initial']}>
          <Stack
            align='center' display='flex' marginRight='16px'
            flexDirection='row' alignItems='center'
            paddingTop='3px'
          >
            {
              status !== 'active' && (<Text color='#A3A3A3' marginRight='8px'>Disabled</Text>)
            }
            <Switch defaultIsChecked={status === 'active'} onChange={onTypeToggle} className='switcher' size='lg' />
          </Stack>
          <Menu>
            <MenuButton role='button' as={Box} rightIcon='chevron-down'>
              <Box
                background='#F5F5F5'
                width='34px'
                height='31px'
                display='flex'
                cursor='pointer'
                borderRadius='5px'
                alignItems='center'
                justifyContent='center'
                position='relative'
                border='1px solid #E4E4E4'
              >
                <Box
                  width='4px'
                  height='4px'
                  background='#000'
                  borderRadius='100%'
                  opacity='1'
                />
                <Box
                  width='4px'
                  height='4px'
                  background='#000'
                  borderRadius='100%'
                  opacity='1'
                  marginLeft='2px'
                  marginRight='2px'
                />
                <Box
                  width='4px'
                  height='4px'
                  background='#000'
                  borderRadius='100%'
                  opacity='1'
                />
              </Box>
            </MenuButton>
            <Box position='absolute' zIndex='1000' left='-25px' top='0'>
              <MenuList>
                <MenuGroup>
                  <MenuItem
                    onClick={() => onDelete(id)}
                    color='#FF0000'
                    minH='48px'
                  >
                    <Image src='/delete_red.svg' alt='delete' mr='12px' />
                    Delete
                  </MenuItem>
                  <MenuItem minH='48px' onClick={() => onEdit(id)}>
                    <Image src='/edit-black.svg' alt='delete' mr='16px' />
                    Edit
                  </MenuItem>
                </MenuGroup>
                <MenuDivider />
                <MenuGroup>
                  <MenuItem onClick={copyToClipboard} minH='40px'>
                    <Image src='/copy_black.svg' alt='copy' mr='10px' />
                    Copy Link
                  </MenuItem>
                </MenuGroup>
              </MenuList>
            </Box>
          </Menu>
        </Flex>
      </Flex>
    </Box>
  )
}

export { EventTypeItem }
